var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1044,
    height: 950,
    viewBox: "0 0 1044 950",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-5.00013 132.5L-5.00008 46.5C-5.00008 -13 16.5397 49.4217 128.5 10.5C245 -30 236.56 66.8465 375.5 99.0001C474.512 121.914 628.272 65.3461 756 99.0001C941.411 147.852 1036.68 324.321 1043.5 497C1049.78 655.898 883.71 651.798 829.115 704.897C764.418 767.823 795.222 871.623 709.514 901.6C607.983 937.112 531.161 850.255 424.172 837.667C269.511 819.469 265.756 977.371 113.329 945.816C-39.097 914.262 -5.0001 956.638 -5.00008 722C-5.00007 472 -5.0002 386.94 -5.00013 132.5Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 47.4999,
    y1: 194.5,
    x2: 1032,
    y2: 875.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D99A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CD06E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftBox);
export default __webpack_public_path__ + "static/media/leftBox.fb975290890ecd17402e8cee1ed22e18.svg";
export { ForwardRef as ReactComponent };